import {reactive} from 'vue'

const globalState = reactive({
  schemas: {}
})

export const useYupComposable = () => {

  function setYup(key, schema) {
    globalState.schemas[key] = schema
  }

  function getYup(key) {
    return globalState.schemas[key]
  }

  return {
    setYup, getYup
  }
}
